import React, { useState, useEffect } from "react";
import "./Hero.css";
import "./WhatWeOffer.css";
import { Link } from "react-router-dom";
import leftArrow from "../assets/left-arrow.png";
import rightArrow from "../assets/right-arrow.png";
import img1 from "../assets/bg-img1.png";
import img2 from "../assets/bg-img2.jpg";
import img3 from "../assets/bg-img3.png";
import img4 from "../assets/bg-img4.png";
import img5 from "../assets/bg-img5.png";
import Screens from "../assets/4. Screens 2.png";
import img7 from "../assets/abt-icon.png";
import img15 from "../assets/solcard-img.JPG";
import img16 from "../assets/off-img2.png";
import img17 from "../assets/capcard-img.jpg";
import dirImg from "../assets/dir-img3.png";

const slides = [
  {
    image: img1,
    title: "World-Class Die-Casting at Scale",
    description:
      "Delivering precision at scale through lean systems, green practices, and connected technologies.",
    buttonText: "Explore Products",
  },
  {
    image: img2,
    title: "Driven by Systems, Powered by People",
    description:
      "A culture rooted in systems excellence and elevated by human capability.",
    buttonText: "Discover How It Works",
    position: "center 12%", // CHANGE 1: image position for this slide only
  },
  {
    image: img3,
    title: "Women Powering Precision",
    description:
      "Building a stronger industry by nurturing women in advanced manufacturing",
    buttonText: "Explore Our Solutions",
  },
  {
    image: img4,
    title: "Sustaining Performance, Respecting the Planet",
    description:
      "Shaping a cleaner tomorrow through conscious manufacturing and community action.",
    buttonText: "View Expertise",
  },
  {
    image: img5,
    title: "Autonomous Monitoring & Robotics",
    description:
      "Autonomous systems transforming productivity through digital intelligence.",
    buttonText: "Learn More",
  },

  // {
  //   image: img6,
  //   title: "Rooted in Responsibility",
  //   description:
  //     "Committed to a greener tomorrow with eco-friendly practices and community-driven initiatives like tree plantations.",
  //   buttonText: "Discover Our Sustainability Journey",
  // },
];

const cards = [
  {
    img: img15,
    title: "Solutions",
    desc: "From concept to casting — integrated solutions for every mobility challenge.",
    link: "/solutions"
  },
  {
    img: img16,
    title: "Technology",
    desc: "Smart processes, advanced materials, and digital innovation driving precision.",
    link: "/technology"
  },
  {
    img: img17,
    title: "Capabilities",
    desc: "World-class R&D, manufacturing excellence, and uncompromising quality.",
    link: "/capabilities"
  }
];

function Hero({ onFinish }) {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const intervalRef = React.useRef(null);
  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 1200);
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 1200);
    setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

 useEffect(() => {
  intervalRef.current = setInterval(() => {
    setCurrent((prev) => {
       console.log("Current slide:", prev);
      if (prev >= slides.length - 1) {
        console.log("Last slide reached, calling onFinish");
        clearInterval(intervalRef.current);
        if (onFinish) {
          setTimeout(() => onFinish(), 0); 
        }
        return prev;
      }
      return prev + 1;
    });
  }, 6000);

  return () => clearInterval(intervalRef.current);
}, [onFinish]);

  return (
    <section>
      {/* ---------- HERO SLIDER ---------- */}
      <section className="hero-container" id="hero">
        {slides.map((slide, index) => {
          let position = "nextSlide";
          if (index === current) position = "activeSlide";
          if (index === (current - 1 + slides.length) % slides.length)
            position = "lastSlide";

          return (
            <div
              key={index}
              className={`hero-slide ${position}`}
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundPosition: slide.position || "center", // CHANGE 2
              }}
            >
              <div className="hero-overlay">
                <div className="hero-text">
                  <h1>{slide.title}</h1>
                  <p>{slide.description}</p>
                  {/* <button>
                    <b>{slide.buttonText}</b>
                  </button> */}
                </div>
              </div>
            </div>
          );
        })}

        {/* Arrows */}
        <div className="arrow-container left-arrow" onClick={prevSlide}>
          <img src={leftArrow} alt="Prev" className="arrow-icon" />
        </div>
        <div className="arrow-container right-arrow" onClick={nextSlide}>
          <img src={rightArrow} alt="Next" className="arrow-icon" />
        </div>
      </section>

     


      <section className="about-section1">
        <h2 className="offer-title about-title">About Us</h2>
        <div className="offer-line about-line"></div>
        <div className="card-container">
          <div className="card1 blue-card">
            <div className="aboutus-card">

              <div className="card-bg">
                <div className="bg-img img1"></div>
                <div className="bg-img img2"></div>
                <div
                  className="bg-img img1c"
                  style={{ backgroundImage: `url(${dirImg})` }}
                ></div>
              </div>

             

              {/* FRONT CONTENT */}
              <div className="card-front">
                <div className="slanted-box">
                  <img src={img7} alt="icon" className="icon1" />
                  <div className="slanted-text">
                    <strong>63</strong> <span>Years Of</span> <br /> Experience
                  </div>
                </div>
              </div>

            </div>
          </div>


          <div className="text-content">
            <h2>Six Decades of Innovation in Light Metal Castings</h2>
            <p>
              Established in <span className="blue">1962, Sundaram Clayton Limited (SCL)</span> is a leading supplier of high-precision aluminium die cast
              components to global automotive players in the commercial vehicle and passenger cars segment. Promoted by the TVS
              Group, led by <span className="blue">Mr. Venu Srinivasan</span>, SCL brings over <span className="blue">six decades</span> of engineering expertise and excellence in light metal
              castings.
            </p>
            <p>
              SCL serves leading <span className="blue">OEMs and Tier-1 suppliers, delivering lightweight, reliable and performance-critical components.</span> We offer end-to-end capabilities spanning design collaboration, prototyping, aluminium die casting, precision machining and sub-assembly—supporting customers from concept to series production. Our Design Centre in <span className="blue">Neckarsulm, Germany,</span> strengthens close co-engineering with global customers, particularly in <span className="blue">lightweighting, structural and electric vehicle (EV) applications.</span>
            </p>
          </div>
        </div>

        <div className="card-container1">
          <div className="text-content1">
            <h2>Smart Manufacturing for a Smarter Future</h2>
            <p>
              SCL's manufacturing ecosystem is designed to meet the demands of tomorrow. Our <span className="blue">mega die-casting plants</span> at <span className="blue">Thervoy Kandigai, Oragadam, Mahindra World City</span> and an overseas facility <span className="blue">USA</span> - powered by automation, smart factory technologies, and lean manufacturing systems - deliver consistent, world-class quality at scale.
            </p>
            <p>
              From real-time production monitoring to digitally integrated <span className="blue">casting and machining lines,</span> our operations reflect a future-ready approach to precision manufacturing. Combined with our strong focus on <span className="blue">sustainability and operational excellence,</span> SCL is building smarter, cleaner, and more agile factories to serve the evolving needs of global mobility.
            </p>
            <p>At SCL, smart manufacturing is not just about automation - it is about enabling customers with <span className="blue">faster development cycles, superior consistency, and scalable global supply.</span></p>
          </div>
          <div className="card2 blue-card1">
  <div className="aboutus-card1">

    <div
      className="card-bg1 bg-one1"
      style={{ backgroundImage: `url(${img5})` }}
    ></div>

<div className="card-bgs bg-two1">
  <img src={Screens} alt="Screens" className="screens-img" />
</div>

 

  </div>
</div>

         
      </div>
      </section>

      <section className="offer-section" id="what-we-offer">
        <h2 className="offer-title">What We Offer</h2>
        <div className="offer-line"></div>

        <div className="offer-cards">
          {cards.map((card, index) => (
            <div className="offer-card" key={index}>
              <div className="offer-image">
                <img src={card.img} alt={card.title} />
              </div>
              <div className="offer-content">
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
                <Link to={card.link} className="offer-link">
                  <span>Explore ↗</span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

    </section>
  );
}

export default Hero;
